/**
 * User credentials DTO
 */
export class UserDto {
    /**
     * Username
     */
    username: string = '';

    /**
     * Password
     */
    password: string = '';
}